module.exports = __webpack_public_path__ + "static/media/FeedbackExpiredMCNew.ab3ce6ac.svg";